/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { UpdateProfileProps } from "./components";
import { pretty } from "@vlinder-web/utils-react";
const is = require("is_js");

const SERVICE_NAME = "CashierPaymentPageService";
const log: any = LoggerModule.getInstance();

export class ViewBoxDetailService {
  private static instance: ViewBoxDetailService;
  private vapp: VApplication;
  private criteria: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): ViewBoxDetailService {
    if (!ViewBoxDetailService.instance) {
      ViewBoxDetailService.instance = new ViewBoxDetailService(props);
    }
    return ViewBoxDetailService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    // Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getUserListsProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }

    compProps = await agent.getMyProfile({});

    let isSelfUsers = {
      isSelfUser: false,
    }
    content.profileDetails.buttons[0].isPresent = true;
    if (content?.ultUsers[0]?.id === compProps?.getMyProfile?.id) {
      isSelfUsers = {
        isSelfUser: true
      }
      content.profileDetails.buttons[0].isPresent = false;
    }
    if (compProps) {
      content = { ...content, ...isSelfUsers };
    }

    compProps = await agent.getRoles({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getSearchContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getUserSearchProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async updateProfile(args: UpdateProfileProps) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.getUpdateProfile(args);
  }

  public async updateRoles(args: any) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.getUpdateRolesProps(args);
  }
}
